import { NavLink } from 'react-router-dom';

const navItems = [
  { path: '/', label: 'Дашборд', icon: DashboardIcon },
  { path: '/users', label: 'Пользователи', icon: UsersIcon },
  { path: '/chats', label: 'Чаты', icon: ChatsIcon },
  { path: '/images', label: 'Изображения', icon: ImageIcon },
  { path: '/model-settings', label: 'Модели', icon: ModelsIcon },
  { path: '/traffic-sources', label: 'Источники трафика', icon: TrafficIcon },
  { path: '/notifications', label: 'Уведомления', icon: NotificationsIcon },
  { path: '/feedback', label: 'Отзывы', icon: FeedbackIcon },
  { path: '/recommendations', label: 'Рекомендации', icon: RecommendationsIcon },
  { path: '/group-subscriptions', label: 'Подписки', icon: GroupSubscriptionsIcon },
];

function DashboardIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M3 3H9V9H3V3Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M11 3H17V9H11V3Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M3 11H9V17H3V11Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M11 11H17V17H11V11Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

function UsersIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M10 10C12.2091 10 14 8.20914 14 6C14 3.79086 12.2091 2 10 2C7.79086 2 6 3.79086 6 6C6 8.20914 7.79086 10 10 10Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4 18C4 15.7909 6.68629 14 10 14C13.3137 14 16 15.7909 16 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

function ChatsIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M3 4.5C3 3.397 3.897 2.5 5 2.5H15C16.103 2.5 17 3.397 17 4.5V11.5C17 12.603 16.103 13.5 15 13.5H7.5L3 17.5V13.5H5C3.897 13.5 3 12.603 3 11.5V4.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

function ImageIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect x="2" y="3" width="16" height="14" rx="2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="6.5" cy="7.5" r="1.5" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M18 13L13 8L5 16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

function ModelsIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M4 5H16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M4 10H16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M4 15H16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="7" cy="5" r="1.5" fill="currentColor"/>
      <circle cx="13" cy="10" r="1.5" fill="currentColor"/>
      <circle cx="9" cy="15" r="1.5" fill="currentColor"/>
    </svg>
  );
}

function FeedbackIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 11.5 2.5 13 3.5 14L3 18L7 17C7.83333 17.5 8.83333 17.8333 10 18Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

function NotificationsIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M10 2C7.239 2 5 4.239 5 7V11L3 13V14H17V13L15 11V7C15 4.239 12.761 2 10 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.5 14C7.5 14.92 7.81 15.77 8.33 16.43C8.85 17.09 9.59 17.5 10.4 17.5C11.21 17.5 11.95 17.09 12.47 16.43C12.99 15.77 13.3 14.92 13.3 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

function TrafficIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M10 2L12.5 7.5L18 8.5L14 12.5L15 18L10 15.5L5 18L6 12.5L2 8.5L7.5 7.5L10 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

function RecommendationsIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M10 2L12.09 6.26L17 7.27L13.5 10.14L14.18 15.02L10 12.77L5.82 15.02L6.5 10.14L3 7.27L7.91 6.26L10 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14 13L16 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6 13L4 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

function GroupSubscriptionsIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M10 10C12.2091 10 14 8.20914 14 6C14 3.79086 12.2091 2 10 2C7.79086 2 6 3.79086 6 6C6 8.20914 7.79086 10 10 10Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4 18C4 15.7909 6.68629 14 10 14C11.7722 14 13.3664 14.5129 14.4644 15.3302" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M15 18L18 15M18 15L15 12M18 15H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export const Sidebar = ({ isOpen, onClose }) => {
  return (
    <>
      {/* Overlay для мобильных */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <aside className={`
        fixed lg:static inset-y-0 left-0 z-50
        w-64 bg-bg-secondary border-r border-border-color
        transform transition-transform duration-300 ease-in-out
        ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
      `}>
        {/* Logo */}
        <div className="h-16 flex items-center px-6 border-b border-border-color">
          <h1 className="text-lg font-semibold text-text-primary">GPT-Free Admin</h1>
        </div>

        {/* Navigation */}
        <nav className="p-4 space-y-1">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              onClick={onClose}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                  isActive
                    ? 'bg-accent-primary/10 text-accent-primary'
                    : 'text-text-secondary hover:bg-bg-tertiary hover:text-text-primary'
                }`
              }
            >
              <item.icon />
              <span className="font-medium">{item.label}</span>
            </NavLink>
          ))}
        </nav>

        {/* Footer */}
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-border-color">
          <div className="text-xs text-text-muted text-center">
            v1.0.0
          </div>
        </div>
      </aside>
    </>
  );
};
